import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './index.css';
import { _auth } from '../../firebase';
import firebase from 'firebase/app';
import {
  BREAKPOINT_VALUES,
  LOGIN_FROM_TYPE,
  LOYALTY_VIEW_INDEX_TYPE,
  ORDER_STAGE_TYPES,
} from 'helpers/enums';
import GoogleIcon from '../../assets/images/googleIcon.svg';
import FacebookIcon from '../../assets/images/facebookIcon.png';
import PhoneIcon from '../../assets/images/phoneIcon.svg';
import AppleIcon from '../../assets/images/appleIcon.svg';
import { UserLoginRegistrationContext } from 'contexts/UserLoginRegistrationProvider';
import { useAuth } from 'contexts/AuthProvider';
import { defaultHomePropsState } from 'constants/common';
import { setState, toggleMobileCart } from 'containers/Home/actions';
import { LoadingIcon } from 'nexticons/outline';
import {
  BackButtonCWUI,
  CloseButtonCWUI,
  CustomerCategoryTitleUI,
} from '@next-order/next-order-components';
import { MenuContext } from 'contexts/MenuProvider';
import { PAGE_TRANSITION_DURATION } from 'containers/Home/constants';

const oAuthButtonClasses =
  'oAuthButton overflow-hidden max-w-full relative inline-flex items-center justify-center ' +
  'space-x-1.75 border transition-colors duration-300 ' +
  'disabled:cursor-not-allowed disabled:opacity-75 outline-primary-outline ' +
  'cursor-pointer w-full pl-2 pr-4 rounded-xl bg-transparent ' +
  'border-transparent text-accent min-h-11.5 text-base text-lg ' +
  'leading-7 tracking-tight font-medium hover:bg-accent ' +
  'focus-visible:bg-accent hover:border-accent focus-visible:border-accent ' +
  'hover:text-white focus-visible:text-white mb-1 bg-white text-black shadow-cw';

export default function OAuthOptions({
  currentOrder,
  updateEngineOrderCalculations,
}) {
  const { storeConfig } = useSelector((state) => state.layoutReducer);
  const { storeLoyaltySettings } = useSelector((state) => state.loyaltyReducer);
  const {
    signInWithGoogle,
    signInWithApple,
    setState: setAuthState,
    loading,
    loginFrom,
  } = useAuth();
  const { breakPoint } = useContext(MenuContext);
  const dispatch = useDispatch();

  const handleContinueWithMobile = () => {
    setAuthState({
      isOauthFlow: false,
      authOrderStage: ORDER_STAGE_TYPES.MOBILE_FORM,
    });
  };

  const storeSettings = storeLoyaltySettings ? storeLoyaltySettings : null;

  const themeColors = storeSettings
    ? {
        backgroundColor: storeSettings.selectedBackgroundColor || '#f9f9f9',
        labelTextColor: storeSettings.selectedLabelTextColor || '#333',
        mainTextColor: storeSettings.selectedMainTextColor || '#666',
      }
    : {
        backgroundColor: '#f9f9f9',
        labelTextColor: '#333',
        mainTextColor: '#666',
      };

  const handleCloseClick = () => {
    setTimeout(() => {
      let orderObj = JSON.parse(JSON.stringify(currentOrder));
      orderObj.stage = ORDER_STAGE_TYPES.NONE;
      updateEngineOrderCalculations(orderObj);
      if (loginFrom !== LOGIN_FROM_TYPE.LOYALTY) {
        dispatch(toggleMobileCart(false));
      }
      setAuthState({ authOrderStage: ORDER_STAGE_TYPES.NONE });
      dispatch(
        setState({
          ...defaultHomePropsState,
          loyaltyOpen: loginFrom === LOGIN_FROM_TYPE.LOYALTY,
        })
      );
    }, PAGE_TRANSITION_DURATION);
  };

  if (loading) {
    return (
      <div className='flex justify-center items-center h-full'>
        <LoadingIcon strokeWidth={3} width={48} />
      </div>
    );
  }
  return (
    <div className='oauth-content-wrapper'>
      {loginFrom === LOGIN_FROM_TYPE.PROFILE ? (
        <CloseButtonCWUI
          extendedClassName='oAuthCloseButton ml-4 mt-1'
          onClick={handleCloseClick}
        />
      ) : (
        <BackButtonCWUI
          extendedClassName='oAuthCloseButton ml-4 mt-1'
          onClick={handleCloseClick}
        />
      )}
      <div className='loyalty-guest-container'>
        <CustomerCategoryTitleUI extendedClassName='oauth-heading'>
          {loginFrom === LOGIN_FROM_TYPE.PROFILE ? 'Log in' : 'Almost there!'}
        </CustomerCategoryTitleUI>
        <div className='oauth-caption text-base mb-8 font-light'>
          <span className='font-medium'>Sign up</span> or{' '}
          <span className='font-medium'>Log in</span> to continue. It only takes
          a minute.
        </div>

        <div className='grid grid-cols-1 gap-6 relative'>
          <button
            type='button'
            className={oAuthButtonClasses}
            title='Continue with Google'
            onClick={signInWithGoogle}
          >
            <img src={GoogleIcon} alt='Google' />
            Continue with Google
          </button>
          <button
            type='button'
            className={oAuthButtonClasses}
            title='Continue with Apple'
            onClick={signInWithApple}
          >
            <img src={AppleIcon} alt='Apple' />
            Continue with Apple
          </button>
          <button
            type='button'
            className={oAuthButtonClasses}
            title='Continue with Mobile'
            onClick={handleContinueWithMobile}
            style={{
              backgroundColor:
                loginFrom === LOGIN_FROM_TYPE.LOYALTY
                  ? themeColors.backgroundColor
                  : storeConfig.storeColorCode || '#e25f28',
              color:
                loginFrom === LOGIN_FROM_TYPE.LOYALTY
                  ? themeColors.mainTextColor
                  : '#fff',
            }}
          >
            <img src={PhoneIcon} alt='Phone' />
            Continue with Mobile
          </button>
        </div>
      </div>
    </div>
  );
}
